import React from "react";
import { Page } from "components";
import classNames from "lib/classNames";
// import WbIcon from "svgs/wb-icon.png";
// import TranscyIcon from "svgs/transcy-icon.png";
// import PageflyIcon from "svgs/pagefly-icon.png";
// import MonsterIcon from "svgs/monster-checkout-icon.png";
// import GorillaIcon from "svgs/gorilla-icon.png";
// import RechargeIcon from "svgs/recharge-icon.jpeg";
// import ZeptoIcon from "svgs/zepto-icon.png";

// const partners = [
//   {
//     name: "Monster Checkout Upsells",
//     description:
//       "Increase Checkout Revenue using One Click Upsell funnels after someone has purchased from your store.",
//     link: "https://apps.shopify.com/monster-checkout",
//     icon: MonsterIcon,
//   },
//   {
//     name: "Widebundle",
//     description:
//       "Increase your AOV by adding bundles and offers to your products. Provide discounts that boost sales.",
//     link: "https://apps.shopify.com/widebundle",
//     icon: WbIcon,
//   },
//   {
//     name: "Transcy - Translate",
//     description:
//       "Transcy allows you to translate the content of your online store into multiple languages and convert the currency into the local currency of the customers.",
//     link: "https://apps.shopify.com/transcy-multiple-languages",
//     icon: TranscyIcon,
//   },
//   {
//     name: "PageFly",
//     description: "Drag and drop to build Landing, Product, Home and Blog pages",
//     link: "https://apps.shopify.com/pagefly",
//     icon: PageflyIcon,
//   },
//   {
//     name: "Wholesale Gorilla",
//     description:
//       "Create a wholesale portal on your store. A simple and powerful B2B solution built by real merchants.",
//     link: "https://apps.shopify.com/wholesale-gorilla",
//     icon: GorillaIcon,
//   },
//   {
//     name: "Recharge Subscriptions",
//     description:
//       "Grow your subscription business with Recharge and enable your customers to fully manage their subscriptions directly from your store.",
//     link: "https://apps.shopify.com/subscription-payments",
//     icon: RechargeIcon,
//   },
//   {
//     name: "Zepto Product Personalizer",
//     description:
//       "Add Unlimited Custom Product Options with Live Preview. A Visual Personalizer to boost sales.",
//     link: "https://apps.shopify.com/product-personalizer",
//     icon: ZeptoIcon,
//   },
// ];

const Integrations = () => {
  return (
    <>
      <Page
        background="white"
        header={{ title: "Integrations & Partners" }}
        padding="p-0"
        additional_classes=" h-full"
      >
        {/* <div className={classNames("bg-white relative rounded shadow p-5 pb-6")}>
        <b className={classNames("text-gray-600 text-md")}>
          We integrate with and recommend these apps
        </b>
        <div
          className={classNames(
            "col-span-1 lg:col-span-3 grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-4"
          )}
        >
          {partners.map((partner) => (
            <div
              className={classNames(
                "flex flex-1 items-start justify-start border border-solid border-gray-500 rounded-md p-3"
              )}
              key={partner.name}
            >
              <div className={classNames("mr-3")}>
                <img
                  src={partner.icon}
                  className={classNames("rounded-md w-12 h-12 max-w-none")}
                />
              </div>
              <div className={classNames("")}>
                <h3
                  className={classNames("font-bold text-sm mb-1 text-gray-600")}
                >
                  {partner.name}
                </h3>
                <p
                  className={classNames(
                    "font-small text-xs leading-4 text-gray-700"
                  )}
                >
                  {partner.description}
                </p>
                <a
                  className={classNames(
                    "font-medium text-xs leading-4 underline text-black mt-2"
                  )}
                  href={partner.link}
                  target="_blank"
                >
                  Learn More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div> */}
        <iframe
          src="https://monsterupsells.partnerpage.io/integrations"
          width="100%"
          height="100%"
          frameborder="0"
          className={classNames("bg-white")}
        ></iframe>
      </Page>
    </>
  );
};

export default Integrations;
